import { type JSX } from 'react';

import { type Bookmaker, type Offer } from '../../types';
import { OffersListItem } from '../OffersListItem';

export const OffersList = ({
  bookmaker,
  eventLabel = '',
  offers,
}: {
  bookmaker: Bookmaker;
  eventLabel?: string;
  offers: Offer[];
}): JSX.Element => {
  return (
    <>
      {offers.map((offer, index) => {
        return (
          <OffersListItem
            bookmaker={bookmaker}
            eventLabel={eventLabel}
            index={index}
            key={`${offer.id}_${index}`}
            offer={offer}
          />
        );
      })}
    </>
  );
};
